import { action, atom } from '@reatom/framework'

import type { ExploreFiltersAtom } from './reatom-explore-filters'

export const reatomExploreFilterDrawer = (options: {}, name: string) => {
  const closeAction = action(
    (ctx) => exploreFilterDrawer(ctx, undefined),
    `${name}.closeAction`,
  )

  const exploreFilterDrawer = atom<ExploreFiltersAtom | undefined>(
    undefined,
    `${name}.exploreFilterDrawer`,
  )

  return {
    exploreFilterDrawer,
    closeAction,
  }
}

export const exploreFilterDrawer = reatomExploreFilterDrawer(
  {},
  'exploreFilterDrawer',
)

export type ExploreFiltersDrawer = ReturnType<typeof reatomExploreFilterDrawer>
